import { render } from "./SettingsBtn.vue?vue&type=template&id=03a4f7fb&ts=true"
import script from "./SettingsBtn.vue?vue&type=script&lang=ts"
export * from "./SettingsBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__